<template>
  <div>
    <top-navbar></top-navbar>
    <div class="mb-5 background_color">
      <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/"> Home </router-link
        ><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span
        >Employee<span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span
        >{{ pageTitle }}
      </h6>

      <div class="container-fluid">
        <div style="border: 0px; padding: 0px; min-height: 0px" class="navbar background_color">
          <div class="d-flex align-items-center">
            <b-input-group size="sm" style="width: 225px;">
              <b-form-input
                id="filter-input"
                class="bdr-rad"
                v-model="filter"
                type="search"
                placeholder="Search roster"
                @input="loadRoster"
              />
            </b-input-group>
            <div style="margin-top: 11px;" class="ms-2">
              <span class="custom-breadcrumb">Showing {{ all_data.length }} items.</span>
            </div>
          </div>

          <div class="d-grid gap-2 d-md-flex justify-content-md-end">
            <button @click="goCreate" class="btn btn-sm btn-outline-primary mb-1 mt-0 bdr-rad">{{ createButtonLabel }}</button>
          </div>
        </div>

        <div class="card bdr-rad2 mt-1 shadow p-2">
          <div class="card-body">
            <div class="table-responsive">
              <b-table
                responsive
                style="font-size: small;"
                class="table-hover"
                :items="all_data"
                :fields="fields"
                show-empty
                small
              >
                <template #cell(id)="row">
                  {{ row.index + 1 }}
                </template>
                <template #cell(action)="row">
                  <div class="dropdown">
                    <button class="btn btn-sm btn-outline-primary dropdown-toggle bdr-rad" type="button" data-toggle="dropdown" aria-expanded="false">
                      Action
                    </button>
                    <div class="dropdown-menu bdr-rad">
                      <a class="dropdown-item mouse-cursor" @click="viewRoster(row.item.id)">View</a>
                      <a v-if="!isActualRoster && Number(row.item.confirm_status) !== 1" class="dropdown-item mouse-cursor" @click="confirmRoster(row.item.id)">Confirm</a>
                    </div>
                  </div>
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <content-footer></content-footer>
  </div>
</template>

<script>
import axios from "axios";
import authService from "@/auth.service";
import TopNavbar from "./../../layout/TopNavbar.vue";
import ContentFooter from "./../../layout/ContentFooter.vue";

export default {
  components: { TopNavbar, ContentFooter },
  data() {
    return {
      access_token: authService.isLoggedIn(),
      filter: "",
      all_data: [],
      fields: [
        { key: "id", label: "ID" },
        { key: "schedule_code", label: "Roster Code" },
        { key: "month_label", label: "Month" },
        { key: "year", label: "Year" },
        { key: "start_date", label: "Start Date" },
        { key: "end_date", label: "End Date" },
        { key: "site", label: "Site" },
        { key: "created_date", label: "Created Date" },
        { key: "created_by", label: "Created By" },
        { key: "action", label: "Action" },
      ],
    };
  },
  mounted() {
    this.loadRoster();
  },
  computed: {
    isActualRoster() {
      return this.$route.path.includes("/roster/actual");
    },
    pageTitle() {
      return this.isActualRoster ? "Manage Actual Roster" : "Manage Schedule Roster";
    },
    createButtonLabel() {
      return this.isActualRoster ? "Back to Schedule Roster" : "Create Schedule Roster";
    },
  },
  methods: {
    goCreate() {
      this.$router.push(this.isActualRoster ? "/roster/index" : "/roster/create");
    },
    viewRoster(id) {
      this.$router.push(this.isActualRoster ? "/roster/actual/view?id=" + id : "/roster/view?id=" + id);
    },
    async confirmRoster(id) {
      try {
        const { data } = await axios.post(
          "/roster/confirm",
          { userid: authService.isUserid(), id },
          { headers: { Authorization: "Bearer " + this.access_token, "Content-Type": "application/json" } }
        );
        if (data.status === 200) {
          await this.loadRoster();
          if (data.actual_schedule && data.actual_schedule.id) {
            this.$router.push("/roster/actual/view?id=" + data.actual_schedule.id);
          }
        }
      } catch (error) {
        console.log(error.response || error);
      }
    },
    async loadRoster() {
      try {
        const endpoint = this.isActualRoster ? "/roster/actualindex" : "/roster/index";
        const { data } = await axios.get(endpoint, {
          params: { filter: this.filter },
          headers: { Authorization: "Bearer " + this.access_token, "Content-Type": "application/json" },
        });
        this.all_data = data.all_data || [];
      } catch (error) {
        console.log(error.response || error);
      }
    },
  },
};
</script>
